import React from 'react';
import { useFormContext } from 'react-hook-form';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import './AppUpdateGeneral.scss';

const AppUpdateGeneral = () => {
  const { watch, setValue } = useFormContext();

  const iosLowestSupportingVersionField = 'iosLowestSupportingVersion';
  const androidLowestSupportingVersionField = 'androidLowestSupportingVersion';

  const iosLowestSupportingVersion = watch(iosLowestSupportingVersionField);
  const androidLowestSupportingVersion = watch(androidLowestSupportingVersionField);

  return (
    <>
      <div className="first-section-title">GENERAL</div>
      <label className="tips-message">
        Input a version number X. Version lower than X will require force update and higher than or equal to X is optional.
      </label>

      <CustomTitleWithInput
        customClass="app-update-general-input"
        title="Lowest supporting version for iOS"
        defaultValue={iosLowestSupportingVersion}
        setValue={(value) => {
          setValue(iosLowestSupportingVersionField, value, { shouldDirty: true, });
        }}
      />

      <CustomTitleWithInput
        customClass="app-update-general-input"
        title="Lowest supporting version for Andriod"
        defaultValue={androidLowestSupportingVersion}
        setValue={(value) => {
          setValue(androidLowestSupportingVersionField, value, { shouldDirty: true, });
        }}
      />
    </>
  );
}

export default AppUpdateGeneral;
